// extracted by mini-css-extract-plugin
module.exports = {"ad_wrapper":"CcSBEh_y","adimg":"X3uij1p4"};